<template>
  <main v-if="product" class="product-detail">
    <router-link class="back" to="/products">← 返回产品中心</router-link>
    <section class="overview">
      <img :src="imageUrl(product.image)" :alt="product.title">
      <div><p>产品介绍</p><h1>{{ product.title }}</h1><p v-for="line in product.description" :key="line" class="description">{{ line }}</p></div>
    </section>
    <section v-if="product.labels.length" class="specification"><p>产品规格</p><h2>技术参数</h2><dl><template v-for="(label, index) in product.labels"><dt :key="'dt' + index">{{ label }}</dt><dd :key="'dd' + index">{{ product.values[index] }}</dd></template></dl></section>
  </main>
  <main v-else class="not-found"><h1>未找到该产品</h1><router-link to="/products">返回产品中心</router-link></main>
</template>

<script>
import productCatalog from '@/data/productCatalog'

export default {
  name: 'ProductDetail',
  computed: {
    product () {
      const id = this.$route.params.id
      const description = productCatalog['desc_' + id]
      if (!description && !productCatalog['image_' + id]) return null
      if (!description) {
        const cityProductNames = { 131: '智慧城市-井盖/井盖锁', 132: '智慧城市-车位锁', 133: '智慧城市-地磁', 134: '智慧城市-烟感', 135: '智慧城市-路灯', 136: '智慧城市-定位器' }
        return { title: cityProductNames[id], description: ['智慧城市物联网感知终端。'], image: productCatalog['image_' + id], labels: [], values: [] }
      }
      return { title: description.title, description: description.desc, image: productCatalog['image_' + id], labels: productCatalog['title_' + id], values: productCatalog['value_' + id] }
    }
  },
  methods: {
    imageUrl (image) {
      const source = Array.isArray(image) ? image[0] : image
      return source.indexOf('static/') === 0 ? '/' + source : '/static/' + source
    }
  }
}
</script>

<style lang="scss" scoped>
.product-detail { min-height: 100vh; padding: 122px 8vw 100px; background: #f4f6f4; color: #111719; }.back { display: inline-block; margin-bottom: 42px; color: #925131; font-size: 14px; }.overview { display: grid; grid-template-columns: 1.1fr .9fr; gap: 8vw; align-items: center; margin-bottom: 130px; }.overview > img { width: 100%; min-height: 480px; object-fit: cover; background: #dfe4e2; }.overview div > p:first-child, .specification > p { margin: 0 0 20px; color: #a65c39; font-family: 'IBM Plex Mono', monospace; font-size: 11px; letter-spacing: .12em; }.overview h1, .specification h2 { margin: 0 0 28px; font-size: clamp(42px, 4vw, 62px); line-height: 1.1; letter-spacing: -.06em; }.description { margin: 0 0 13px; color: #445053; font-size: 16px; line-height: 1.85; }.specification { max-width: 1080px; }.specification h2 { font-size: 40px; }.specification dl { display: grid; grid-template-columns: 230px 1fr; margin: 42px 0 0; border-top: 1px solid #c7cdcb; }.specification dt, .specification dd { margin: 0; padding: 19px 0; border-bottom: 1px solid #c7cdcb; font-size: 14px; line-height: 1.7; }.specification dt { font-weight: 600; }.specification dd { color: #4b5759; }.not-found { min-height: 70vh; padding: 180px 8vw; } @media (max-width: 760px) { .product-detail { padding: 104px 24px 68px; }.overview { grid-template-columns: 1fr; gap: 36px; margin-bottom: 82px; }.overview > img { min-height: 330px; }.specification dl { grid-template-columns: 1fr; }.specification dt { padding-bottom: 4px; border-bottom: 0; }.specification dd { padding-top: 4px; } }
</style>
